/**
 * Cài đặt bảo mật – Mã PIN Quản trị, MFA, Quản lý thiết bị.
 * Migrated to Supabase via Identity domain.
 */

import { identityDomain } from '@domain/identity/IdentityDomainFactory';

/**
 * Lấy cài đặt bảo mật (adminPin, mfaEnabled, devices).
 * @param {string} uid - User ID (chủ quán)
 * @returns {Promise<{ adminPin?: string, mfaEnabled?: boolean, devices?: Array<{ id, userAgent, lastActive }> }>}
 */
export async function getSecuritySettings(uid) {
  if (!uid) return { adminPin: '', mfaEnabled: false, devices: [] };
  const repo = identityDomain.getIdentityRepository();
  return await repo.getSecuritySettings(uid);
}

/**
 * Cập nhật cài đặt bảo mật (chỉ ghi các field truyền vào).
 * @param {string} uid
 * @param {{ adminPin?: string, mfaEnabled?: boolean, devices?: array }} payload
 */
export async function setSecuritySettings(uid, payload) {
  if (!uid) throw new Error('Người dùng chưa đăng nhập.');
  const repo = identityDomain.getIdentityRepository();
  await repo.saveSecuritySettings(uid, payload);
}

/**
 * Thêm hoặc cập nhật thiết bị hiện tại vào danh sách (userAgent, lastActive, ipAddress).
 * @returns {Promise<{ isNewDevice: boolean } | void>}
 */
export async function addOrUpdateDevice(uid) {
  if (!uid) return;
  const repo = identityDomain.getIdentityRepository();
  const current = await repo.getSecuritySettings(uid);
  const devices = Array.isArray(current.devices) ? [...current.devices] : [];
  
  const userAgent = typeof navigator !== 'undefined' ? navigator.userAgent : '';
  const now = new Date().toISOString();
  const existing = devices.find((d) => d.userAgent === userAgent);
  
  let isNewDevice = false;
  if (existing) {
    existing.lastActive = now;
  } else {
    isNewDevice = true;
    const id = `device_${Date.now()}_${Math.random().toString(36).slice(2, 9)}`;
    devices.push({ id, userAgent, lastActive: now, ipAddress: null });
  }
  
  await repo.saveSecuritySettings(uid, { devices });
  return { isNewDevice };
}
